import { Config } from "../../../configurations/config";
export const CalendarHolidays_API = {
  //------------------------ CalendarHolidays_API Listing Screen API -----------------------//
  CreateCalendarHoliday:`${Config.server_url}${Config.api_prefix}/CalendarHoliday`,
  GetCalendarHolidaysbyPagination: `${Config.server_url}${Config.api_prefix}/CalendarHoliday`,
  CalculateCalendarHoliday:`${Config.server_url}${Config.api_prefix}/CalendarHoliday/CalculateCalendarHolidayDuration`,
  DeleteCalendarHoliday:`${Config.server_url}${Config.api_prefix}/CalendarHoliday`
};
